/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JsonCompanySerieInfo,
    JsonCompanySerieInfoFromJSON,
    JsonCompanySerieInfoFromJSONTyped,
    JsonCompanySerieInfoToJSON,
} from './JsonCompanySerieInfo';

/**
 * 
 * @export
 * @interface ApiResultOfJsonCompanySerieInfo
 */
export interface ApiResultOfJsonCompanySerieInfo {
    /**
     * 
     * @type {JsonCompanySerieInfo}
     * @memberof ApiResultOfJsonCompanySerieInfo
     */
    data?: JsonCompanySerieInfo;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonCompanySerieInfo
     */
    message?: string;
    /**
     * 
     * @type {object}
     * @memberof ApiResultOfJsonCompanySerieInfo
     */
    messageValues?: object;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonCompanySerieInfo
     */
    requestId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonCompanySerieInfo
     */
    result?: ApiResultOfJsonCompanySerieInfoResultEnum;
}

/**
* @export
* @enum {string}
*/
export enum ApiResultOfJsonCompanySerieInfoResultEnum {
    Ok = 'OK',
    Error = 'ERROR'
}

export function ApiResultOfJsonCompanySerieInfoFromJSON(json: any): ApiResultOfJsonCompanySerieInfo {
    return ApiResultOfJsonCompanySerieInfoFromJSONTyped(json, false);
}

export function ApiResultOfJsonCompanySerieInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResultOfJsonCompanySerieInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : JsonCompanySerieInfoFromJSON(json['data']),
        'message': !exists(json, 'message') ? undefined : json['message'],
        'messageValues': !exists(json, 'messageValues') ? undefined : json['messageValues'],
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function ApiResultOfJsonCompanySerieInfoToJSON(value?: ApiResultOfJsonCompanySerieInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': JsonCompanySerieInfoToJSON(value.data),
        'message': value.message,
        'messageValues': value.messageValues,
        'requestId': value.requestId,
        'result': value.result,
    };
}

